import Axios from "axios";
import {
  SET_PROMOTION_REPORT_LIST,
  UNSET_PROMOTION_REPORT_LIST,
} from "@/store/mutation-types";
import {
  getPromotionReport,
} from "@/store/api";

const state = {
  getPromotionReport: [],
};

const getters = {
  getPromotionReport(state) {
    return state.getPromotionReport;
  },
};

const mutations = {
  [SET_PROMOTION_REPORT_LIST](state, data) {
    state.getPromotionReport = data;
  },
  [UNSET_PROMOTION_REPORT_LIST](state) {
    state.getPromotionReport = [];
  },
};

const actions = {
  getPromotionReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getPromotionReport}`, { params: data })
        .then((response) => {
          commit(SET_PROMOTION_REPORT_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_PROMOTION_REPORT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

